/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Products } from '../../models/products';
import { StockUpdateRequestProducts } from '../../models/stock-update-request-products';

export interface UpdateStocks$Params {
  
    /**
     * XML payload containing products and their stock quantities to synchronize
     */
    body: StockUpdateRequestProducts
}

export function updateStocks(http: HttpClient, rootUrl: string, params: UpdateStocks$Params, context?: HttpContext): Observable<StrictHttpResponse<Products>> {
  const rb = new RequestBuilder(rootUrl, updateStocks.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/xml');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Products>;
    })
  );
}

updateStocks.PATH = '/stocks';
